import {DialogContent, ListItem, ListSubheader, styled} from '@mui/material';

const StyledDialogContent = styled(DialogContent)`
	padding: 16px 24px 24px;
`;

const StyledListSubheader = styled(ListSubheader)`
	font-weight: 600;
	padding-inline: 0;
	top: -16px;
`;

const StyledListItem = styled(ListItem)`
	padding-inline: 0;
	&:last-of-type {
		padding-bottom: 0;
	}
`;

export {StyledDialogContent, StyledListSubheader, StyledListItem};
